<template>
    <div :class="['header', 'header--with-button']" class="tw-flex tw-flex-row tw-items-center tw-border-b-4 tw-border-secondary tw-pb-4 tw-mb-4">
        <h1 class="tw-text-5xl tw-capitalize tw-text-secondary" :class="{ heading_class }">
            {{ heading }}
        </h1>
        <div class="tw-flex tw-gap-4">
            <v-btn v-show="showButton" @click="handleButtonClick" :loading="buttonLoading" class="main-btn">{{ buttonText }}</v-btn>
            <v-btn v-show="secondShowButton" @click="secondHandleButtonClick" :loading="secondButtonLoading" class="main-btn">{{ secondButtonText }}</v-btn>
        </div>
    </div>

</template>

<script>


export default {
    name: "InternalHeader",
    props: {
        heading: {
            type: String,
            required: true
        },
        heading_class: {
            type: String,
            required: false
        },
        buttonText: {
            type: String,
            required: false,
        },
        buttonLink: {
            type: Function,
            required: false,
        },
        showButton: {
            type: Boolean,
            default: false
        },
        buttonLoading: {
            type: Boolean,
            default: false,
        },
        secondButtonText: {
            type: String,
            required: false,
        },
        secondButtonLink: {
            type: Function,
            required: false,
        },
        secondShowButton: {
            type: Boolean,
            default: false
        },
        secondButtonLoading: {
            type: Boolean,
            default: false,
        },

    },
    methods: {
        handleButtonClick() {
            if (this.buttonLink && typeof this.buttonLink === 'function') {
                this.buttonLink(); // Call the parent's click event handler
            }
        },
        secondHandleButtonClick() {
            if (this.secondButtonLink && typeof this.secondButtonLink === 'function') {
                this.secondButtonLink(); // Call the parent's click event handler
            }
        },
    },
}
</script>
<style scoped>
.header--with-button {
    display: flex;
    justify-content: space-between;
}
</style>
